import script from "./Adventure.vue?vue&type=script&setup=true&lang=js"
export * from "./Adventure.vue?vue&type=script&setup=true&lang=js"

import "./Adventure.vue?vue&type=style&index=0&id=8c799f64&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c799f64"]])

export default __exports__